import { authApi } from '@xtnd/web/features/auth/api';

/**
 * Check if the current user has access to reset replication metadata
 * Allowed emails:
 * - @thecoraledge.com
 * - @xtnd.legal
 * - xtnd-setup@theestatelawyers.com
 */
export function canResetReplication(): boolean {
  const user = authApi.getCurrentUser();
  if (!user?.email) {
    return false;
  }

  const email = user.email.toLowerCase();
  
  // Check for specific email
  if (email === 'xtnd-setup@theestatelawyers.com') {
    return true;
  }

  // Check for allowed domains
  const allowedDomains = ['@thecoraledge.com', '@xtnd.legal'];
  return allowedDomains.some(domain => email.endsWith(domain));
}
